import React, { Component } from 'react'
import { Button, TextInput, Loading } from 'carbon-components-react'
import ForgotPasswordAPI from '../api/ForgotPasswordAPI'
import UrlBuilder from '../shared/urlBuilder/UrlBuilder'
import PropTypes from 'prop-types'
import { LiveAnnouncer, LiveMessage } from 'react-aria-live'
import { emailRegEx } from '../../utils/regExpressionsUtils'
import { trackEventMessage, trackEventMessageFailure } from '../../TelemetryService'
import { forgotPasswordFailureMessage, forgotPasswordSuccessMessage } from '../../constants'
import { EventModel } from './../../models/EventModel'
import { FORGOT_PASSWORD } from './../../constants'

export default class ForgotPassword extends Component  {

    constructor() {
        super()
        this.state = {
            enableSubmit:false,
            email: '',
            error: '',
            loading: false
        }
        this.handleEmailValid = this.handleEmailValid.bind( this )
        this.handleSubmit = this.handleSubmit.bind( this )
        this.handleEmailOnChange = this.handleEmailOnChange.bind( this )
    }

    get config() {
        return this.props.config || {}
    }

    get logInUrl() {
        return this.config.logInUrl || process.env.REACT_APP_LOG_IN 
    }

    get forgotPasswordApiUrl() {
        return this.config.forgotPasswordApiUrl || process.env.REACT_APP_FORGOT_PASSWORD_API_URL 
    }

    handleEmailValid = e => {
  
        if( emailRegEx.regEx.test(  e.target.value ) ){
            this.setState( { enableSubmit: true, error: null, email : e.target.value } )
        }else{
            this.setState( { enableSubmit: false, error: emailRegEx.errorMsg, email : e.target.value } )
        }
        if( e.target.value == '' ){
            this.setState( { enableSubmit: false, error: null, email : e.target.value } )
        }
    }

    handleEmailOnChange = e => {
        this.setState( { email : e.target.value } )

        if( emailRegEx.regEx.test(  e.target.value ) ){
            this.setState( { enableSubmit: true,  error: null } )
        }else{
            this.setState( { enableSubmit: false } )
        }
        if( e.target.value == '' ){
            this.setState( { enableSubmit: false } )
        }
    } 

    handleSubmit = e =>{
       
        const { showConfirmation } = this.props
        const { email, error, enableSubmit } = this.state
        e.preventDefault()
        this.setState( { loading: true } )
        if( !error && enableSubmit ){
            ForgotPasswordAPI( {
                email: email,
                apiUrl: this.forgotPasswordApiUrl
            } )
            .then( () => {
                trackEventMessage( new EventModel( FORGOT_PASSWORD.SUCCESS ) )
                showConfirmation( email )
            } )
            .catch( ( ex ) => {
                trackEventMessageFailure( new EventModel( FORGOT_PASSWORD.FAILURE, email ), ex  )
                showConfirmation( email )
            } )
        }else{
            this.setState( { loading: false } )
        }

    }
    render() {
        const{ error, loading, email, enableSubmit } = this.state
        const title = 'Request Password Reset?'
        const message ='Get a link to reset your password if you forgot yours or are locked out of your account.'
        const ariaMessage = title +'. '+ message
        return (
            <>
                <main className="c-main forgot-password">
                    <div className="os-container--max-width">
                        <div className="c-form-card">
                            <div className="c-form-card__container" tabIndex={ 0 }>
                                <h1 className="o-heading-alpha" tabIndex={ 0 } >{ title }</h1>
                                
                                <form onSubmit = { this.handleSubmit }>
                                    <p className="u-type-size-2 mb-7" tabIndex={ 0 }>{ message }</p>
                                    <div className="form-group-forgot-password mb-8">
                                        <TextInput 
                                        labelText="Email" 
                                        className="form-input-forgot-password" 
                                        id="Email" 
                                        type="text" 
                                        autoComplete="false"
                                        invalidText= { error }
                                        invalid={ error ? true : false } 
                                        tabIndex={ 0 }
                                        value={ email } 
                                        onBlur={ this.handleEmailValid }
                                        onChange={ this.handleEmailOnChange }
                                        aria-label={ 'Enter Email field' +'. '+ ariaMessage }
                                        autoFocus={ true } />
                                    </div>
                                    {
                                        error ?
                                            <LiveAnnouncer>
                                                <LiveMessage message= { error } aria-live="polite" />
                                            </LiveAnnouncer>
                                            : null
                                    }
                                    {
                                        loading ?
                                            <Loading
                                            description= { null } className="center-spinner" withOverlay={ false } small = { true }
                                            />
                                            :
                                            <Button   
                                            className={ ` ${ enableSubmit ? 'c-btn c-btn--primary' : 'c-btn c-btn--disabled' } mb-5` } 
                                            type="submit"
                                            tabIndex={ 0 }
                                            aria-label={ `Send Reset Link ${ enableSubmit ? 'Enabled' : 'Disabled' } ` }
                                            data-testid="btn-Submit">
                                                Send Reset Link
                                            </Button>
                                    }
                                    <div className="u-text-center mb-3">  
                                        <a href={ UrlBuilder( { url: this.logInUrl, buildURL: true } ) } className="c-link" tabIndex={ 0 }>Back to Sign In</a>
                                    </div>                                  
                                </form>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        )
    }
}

ForgotPassword.propTypes = {
    showConfirmation: PropTypes.func.isRequired,
    config: PropTypes.shape( {
        logInUrl: PropTypes.string,
        forgotPasswordApiUrl: PropTypes.string
    } )
}
